import { atom } from 'recoil';
export const manageTeachersState = atom({
    key: 'manageTeachers',
    default: {
        teachers: { data: [], count: 0, page: 0, pageCount: 0, total: 0 },
        isTableLoading: false,
        isLoading: false,
        reloadTeachers: false,
        classes: [],
        grades: [],
        filters: { input: '', deleted: false, selectedClassId: '0' },
        dataNotFound: false,
        checked: false,
        isAddTeacherModalVisible: false,
        isUpdateTeacherModalVisible: false,
        isDeleteModalVisible: false,
        isSoftDeleteModalVisible: false,
        isSuccessModalVisible: false,
        teacherToUpdate: null,
        teacherToDelete: null,
        teacherToSoftDelete: null
    }
});
export const teacherForm = atom({
    key: 'teacherForm',
    default: {
        title: '',
        isLoading: false,
        isFormInvalid: false,
        mainError: '',
        dirtyFields: { firstName: false, lastName: false, email: false },
        firstName: '',
        lastName: '',
        email: '',
        firstNameError: '',
        lastNameError: '',
        emailError: '',
        grades: []
    }
});
